import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountOnboardingService, OrganizationData } from '../../services/authentication/accountOnboardingService';

export const useOrganizationCreation = (connectedAccountId: string | undefined) => {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const createOrganization = async () => {
    try {
      // Get stored organization data
      const orgData = JSON.parse(sessionStorage.getItem('orgCreationData') || '') as OrganizationData;
      if (!orgData) {
        throw new Error('No organization data found');
      }

      if (!connectedAccountId) {
        throw new Error('No connected account ID found');
      }

      await AccountOnboardingService.createOrganization(orgData, connectedAccountId);
      
      // Clean up session storage
      sessionStorage.removeItem('orgCreationData');
      sessionStorage.removeItem('fromOrgCreate');
      
      // Navigate to dashboard after successful signup
      navigate(`/${orgData.orgId}/dashboard`);
    } catch (error) {
      console.error('Error creating organization:', error);
      setError(error instanceof Error ? error.message : 'An unknown error occurred');
      if (connectedAccountId) {
        // AccountOnboardingService.deleteStripeAccount(connectedAccountId);
      }
    }
  };

  return {
    error,
    setError,
    createOrganization
  };
}; 